import { Vorvertrag } from '@ps20-frontend/frontend-models';
import { VertragEigenschaftHinweis } from '@ps20/bff-models';

function isCanceledOverOneYear(vertrag: Vorvertrag): boolean {
  return vertrag.eigenschaftHinweise?.some(
    hinweis => hinweis.eigenschaftHinweis === VertragEigenschaftHinweis.VERTRAG_STORNIERT_MEHR_ALS_EIN_JAHR
  ) ?? false;
}

export function hasManuallyEnteredVorvertragCanceledOverOneYear(
  vorvertraege: Vorvertrag[]
): boolean {
  if (!vorvertraege || vorvertraege.length === 0) {
    return false;
  }

  return vorvertraege.some(isCanceledOverOneYear);
}

export function getCanceledManualVorvertragNumbers(
  vorvertraege: Vorvertrag[]
): string[] {
  if (!vorvertraege || vorvertraege.length === 0) {
    return [];
  }

  return vorvertraege
    .filter(isCanceledOverOneYear)
    .map(vertrag => vertrag.vertragsnummer);
}
